import React from "react";
import { getDefaultName } from "../../../utils";

export default function RefereeDashboardAside({
  assignments = [],
  selectedCourseId,
  onSelectCourse,
  translate = (s) => s,
}) {
  const rows = Array.isArray(assignments) ? assignments.filter((r) => r?.course?.id) : [];

  return (
    <div className="col-lg-3 mt-4 mt-lg-0 hide-on-small participant-dashboard-sidebar">
      <aside className="sidebar mt-2 participant-dashboard-nav" id="sidebar">
        <ul className="participant-dashboard-nav__list text-2 kfont lan-text-right">
          <li className="participant-dashboard-nav__item">
            <span className="referee-dashboard-section__label d-block px-2 pt-2">
              {translate("Your contests")}
            </span>
          </li>
          {rows.length === 0 && (
            <li className="participant-dashboard-nav__item">
              <p className="participant-dashboard-nav__empty mb-0">
                {translate("No contests assigned")}
              </p>
            </li>
          )}
          {rows.map((row) => {
            const course = row.course;
            const active = course.id === selectedCourseId;
            return (
              <li key={course.id} className="participant-dashboard-nav__item">
                <button
                  type="button"
                  className={`participant-dashboard-nav__row${
                    active ? " participant-dashboard-nav__row--active" : ""
                  }`}
                  onClick={() => onSelectCourse && onSelectCourse(course.id)}
                >
                  <span className="participant-dashboard-nav__chev" aria-hidden>
                    <i className="fas fa-gavel" />
                  </span>
                  <span className="participant-dashboard-nav__label text-color-primary">
                    {getDefaultName(course.names)}
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      </aside>
    </div>
  );
}
